import { Component, Input } from '@angular/core';
import { PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-list-title',
    templateUrl: 'insurance-list-title.component.html',
    styleUrls: [ 'insurance-list-title.component.scss' ],
})
export class InsuranceListTitleComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    public productIdEnum = PolicyProductIdEnum;
    public DOG_BREED_UNKNOWN = 'DIER0999';
    public CAT_BREED_UNKNOWN = 'DIER0998';

    public fullAddressAsString(): string {
        const streetName = this.purchasedProduct.product.home.streetName;
        const civicNumber = this.purchasedProduct.product.home.civicNumber;
        const civicNumberSuffix = this.purchasedProduct.product.home.civicNumberSuffix;
        const postalCode = this.purchasedProduct.product.home.postalCode;
        const city = this.purchasedProduct.product.home.city;

        return `${streetName} ${civicNumber}${civicNumberSuffix ? ' ' + civicNumberSuffix : ''}, ${postalCode} ${city}`;
    }
}
